import React from "react";
import Modal, { ModalBody, ModalFooter } from "../Modal";
import { Button } from "../primitives";

/**
 * Small confirm dialog (stands in for the app's showAlert confirm). Escape / scrim cancel unless `busy`.
 * `testId` (like mobile CustomAlert's testID): buttons get `${testId}.confirm` / `${testId}.cancel`.
 */
export default function ConfirmModal({ title, children, confirmLabel = "Confirm", cancelLabel = "Cancel", danger = false, busy = false, testId = "alert", onConfirm, onClose }) {
  return (
    <Modal title={title} size="narrow" lock={busy} onClose={onClose} testId={testId}>
      <ModalBody>
        <div className="muted" style={{ fontSize: 14 }}>{children}</div>
      </ModalBody>
      <ModalFooter>
        <Button variant="ghost" onClick={onClose} disabled={busy} data-testid={`${testId}.cancel`}>{cancelLabel}</Button>
        <Button variant={danger ? "dangerSolid" : "pri"} onClick={onConfirm} disabled={busy} data-testid={`${testId}.confirm`}>{confirmLabel}</Button>
      </ModalFooter>
    </Modal>
  );
}
